// Cadre d'un guide (src/content/guides) : fil d'Ariane, en-tête, corps en
// colonne étroite (mêmes styles que les pages légales), FAQ, appel à
// l'action et « à lire ensuite ». Pose aussi tout le <head> : titre,
// description, canonique, Open Graph et données structurées Article +
// BreadcrumbList + FAQPage.
//
// Un guide n'est pas une page légale : il a UN objectif, amener à
// /register. D'où l'appel à l'action après le corps, et pas avant — un
// visiteur venu de Google veut d'abord la réponse à sa question.
import { Link } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import { useT } from '../../lib/i18n'
import { useSeo, articleLd, breadcrumbLd, faqLd } from '../../lib/seo'
import { relatedGuides } from '../../content/guides'

function human (iso) {
  const d = new Date(iso + 'T00:00:00')
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
}

export default function GuideShell ({ guide }) {
  const t = useT()
  const g = t.seo.guides
  const path = `/guides/${guide.slug}`
  const modified = guide.modified || guide.published

  useSeo({
    title: guide.seoTitle || guide.title,
    description: guide.description,
    path,
    type: 'article',
    published: guide.published,
    modified,
    jsonLd: [
      articleLd({ title: guide.title, description: guide.description, path, published: guide.published, modified }),
      breadcrumbLd([
        { name: g.crumbHome, path: '/' },
        { name: g.crumbGuides, path: '/guides' },
        { name: guide.title, path }
      ]),
      guide.faq?.length ? faqLd(guide.faq) : null
    ]
  })

  // Choix de l'auteur + voisins de rubrique + les moins liés : voir
  // relatedGuides() dans src/content/guides/index.js.
  const next = relatedGuides(guide)

  return (
    <div className="u">
      <Navbar />

      <main className="u-legal u-guide">
        <div className="u-wrap">
          <nav className="u-guide__crumbs" aria-label="Breadcrumb">
            <Link to="/">{g.crumbHome}</Link>
            <span aria-hidden="true">/</span>
            <Link to="/guides">{g.crumbGuides}</Link>
          </nav>

          <header className="u-legal__head">
            {guide.kicker && <span className="u-lab">{guide.kicker}</span>}
            <h1 className="u-h2">{guide.title}</h1>
            <p className="u-legal__intro">{guide.intro}</p>
            <p className="u-legal__date">
              {g.updated(human(modified))}
              {guide.minutes ? ` · ${g.minutes(guide.minutes)}` : ''}
            </p>
          </header>

          <article className="u-legal__body">
            {guide.body}

            {guide.faq?.length > 0 && (
              <section className="u-guide__faq">
                <h2>{guide.faqTitle || 'Questions'}</h2>
                <div className="u-faq">
                  {guide.faq.map(({ q, a }) => (
                    <details key={q}>
                      <summary>{q}<span className="u-faq__ic" aria-hidden="true" /></summary>
                      <p className="u-faq__a">{a}</p>
                    </details>
                  ))}
                </div>
              </section>
            )}
          </article>

          <aside className="u-guide__cta">
            <p className="u-guide__cta-t">{g.ctaTitle}</p>
            <p className="u-guide__cta-p">{g.ctaBody}</p>
            <Link to="/register" className="u-btn u-btn--main u-btn--lg">{t.nav.start}</Link>
            <p className="u-guide__cta-n">{g.ctaNote}</p>
          </aside>

          {next.length > 0 && (
            <section className="u-guide__next">
              <h2 className="u-lab">{g.next}</h2>
              <div className="u-guides u-guides--tight">
                {next.map(n => (
                  <Link key={n.slug} to={`/guides/${n.slug}`} className="u-gcard">
                    {n.kicker && <span className="u-gcard__k">{n.kicker}</span>}
                    <span className="u-gcard__t">{n.title}</span>
                    <span className="u-gcard__p">{n.description}</span>
                  </Link>
                ))}
              </div>
            </section>
          )}
        </div>
      </main>

      <Footer />
    </div>
  )
}
